import React from 'react';
import { motion } from 'framer-motion';
export function LifestyleBreak() {
  return <section className="relative w-full h-[50vh] md:h-[80vh] bg-cover bg-center md:bg-fixed" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/44EDkrxSH9Qac4bkqT2AGj/Misery_perfil_4.webp)'
  }} data-id="element-56">
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50" data-id="element-57" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center" data-id="element-58">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-bebas text-4xl md:text-6xl lg:text-7xl text-white tracking-wider max-w-4xl" data-id="element-59">
          EL ESTILO SE VE DESDE CUALQUIER ÁNGULO.
        </motion.p>
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="font-inter text-gray-300 text-lg md:text-xl mt-4 max-w-2xl" data-id="element-60">
          Diseñada para los que no necesitan presentación.
        </motion.p>
        <motion.button initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.5
      }} onClick={() => document.getElementById('precio')?.scrollIntoView({
        behavior: 'smooth'
      })} className="mt-8 bg-misery-purple hover:bg-misery-magenta transition-all duration-300 text-white font-bebas text-2xl md:text-3xl px-12 py-5 tracking-wider transform hover:scale-105" data-id="element-61">
          CONSÍGUELO AHORA
        </motion.button>
      </div>
    </section>;
}